import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

interface HasRegionPermissionProps {
  children: React.ReactNode
  allowedRegions: readonly string[]
}

const LOCALHOST = 'localhost'

const HasRegionPermission = ({ children, allowedRegions }: HasRegionPermissionProps) => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)
  const hasPermission =
    selectedRegion === LOCALHOST || allowedRegions.some(r => selectedRegion.startsWith(r) || selectedRegion.includes(`.${r}.`))

  if (!hasPermission) return null
  return children as React.ReactElement
}

export default HasRegionPermission
